import Vue from 'vue'

import {
  Button,
  Descriptions,
  Row,
  Col,
  Tooltip,
  Icon,
  Space,
  Divider,
  List,
  Checkbox,
  Modal,
  Input,
  message,
  FormModel,
  Upload,
  Collapse,
  Tag,
  Popconfirm,
  Layout,
  DatePicker,
  TimePicker,
  ConfigProvider,
  Spin,
  Empty,
  Tabs,
  Table,
  BackTop,
  Menu,
  InputNumber,
  Select,
  Pagination,
  Notification,
  Popover,
  Transfer,
  PageHeader,
  Progress,
  Switch,
  Dropdown,
  Avatar,
  Breadcrumb,
  Drawer
} from 'ant-design-vue'

Vue.component(Button.Group.name, Button.Group)
Vue.component(Button.name, Button)
Vue.component(Descriptions.name, Descriptions)
Vue.component(Descriptions.Item.name, Descriptions.Item)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Tooltip.name, Tooltip)
Vue.component(Icon.name, Icon)
Vue.component(Space.name, Space)
Vue.component(Divider.name, Divider)
Vue.component(List.name, List)
Vue.component(List.Item.name, List.Item)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Checkbox.Group.name, Checkbox.Group)
Vue.use(Modal)
Vue.component(Input.name, Input)
Vue.component(Input.TextArea.name, Input.TextArea)
Vue.component(FormModel.name, FormModel)
Vue.component(FormModel.Item.name, FormModel.Item)
Vue.component(Upload.Dragger.name, Upload.Dragger)
Vue.component(Upload.name, Upload)
Vue.component(Collapse.name, Collapse)
Vue.component(Collapse.Panel.name, Collapse.Panel)
Vue.component(Tag.name, Tag)
Vue.component(Popconfirm.name, Popconfirm)

Vue.component(Layout.name, Layout)
Vue.component(Layout.Header.name, Layout.Header)
Vue.component(Layout.Sider.name, Layout.Sider)
Vue.component(Layout.Content.name, Layout.Content)
Vue.component(Layout.Footer.name, Layout.Footer)

Vue.component(DatePicker.name, DatePicker)
Vue.component(DatePicker.RangePicker.name, DatePicker.RangePicker)

Vue.use(TimePicker)
Vue.use(InputNumber)

Vue.component(ConfigProvider.name, ConfigProvider)
Vue.component(Spin.name, Spin)
Vue.component(Empty.name, Empty)

Vue.component(Tabs.name, Tabs)
Vue.component(Tabs.TabPane.name, Tabs.TabPane)
Vue.component(Table.name, Table)

Vue.component(BackTop.name, BackTop)

Vue.component(Menu.name, Menu)
Vue.component(Menu.Item.name, Menu.Item)
Vue.component(Menu.Divider.name, Menu.Divider)

Vue.component(Select.name, Select)
Vue.component(Select.Option.name, Select.Option)

Vue.component(Pagination.name, Pagination)
Vue.component(Popover.name, Popover)

Vue.component(Transfer.name, Transfer)

Vue.component(PageHeader.name, PageHeader)
Vue.component(Progress.name, Progress)

Vue.component(Switch.name, Switch)
Vue.component(Dropdown.name, Dropdown)
Vue.component(Avatar.name, Avatar)

Vue.component(Breadcrumb.name, Breadcrumb)
Vue.component(Breadcrumb.Item.name, Breadcrumb.Item)

Vue.component(Drawer.name, Drawer)

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$warning = Modal.warning
Vue.prototype.$message = message
Vue.prototype.$message = message
Vue.prototype.$notification = Notification
